import components from './en_US/components';
import pages from './en_US/pages';
import seo from './en_US/seo';

export default {
  ...pages,
  ...components,
  ...seo,
};
